<template>
  <div class="HistoryList-wrapper">
    <Intro textContent="Our World" imageFileName="akahata.jpg" imageAlt="魚の鱗" />
    <PostLiist :limit=7 :flagPagenation=true />
  </div>
</template>

<script>
import Intro from '@/features/common/Intro.vue';
import PostLiist from "@/features/common/PostList.vue";

export default {
  components: {
    Intro,
    PostLiist,
  },
};
</script>

<style scoped>
.HistoryList-wrapper{
  position: relative;
  width: 80%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 100px;
  margin-left: 10%;
  margin-right: 10%;
  margin-bottom: 100px;
}

/* タブレット、スマートフォン向けのスタイル */
@media screen and (max-width: 570px) {

  .HistoryList-wrapper{
  width: 80%;
  row-gap: 80px;
  margin-bottom: 80px;
}

}
</style>